import {Injectable} from '@angular/core';
import {DiscoveryGa4AngularService} from 'discovery-ga4-angular';
import {QuotationService} from '../quotation-service/quotation.service';

@Injectable()
export class GtmService {
  private _formName: string;
  private _leadRef: Number;
  private _dobFieldAbandonmentTrackingFired: boolean;
  private _registrationAbandonmentTrackingFired: boolean;
  private _vinAbandonmentTrackingFired: boolean;
  private _suburbAbandonmentTrackingFired: boolean;
  private _selectSecurityAbandonmentTrackingFired: boolean;
  private _primaryDriverNameAbandonmentTrackingFired: boolean;
  private _primaryDriverSurnameAbandonmentTrackingFired: boolean;
  private _primaryDriverCellNumberAbandonmentTrackingFired: boolean;
  private _primaryDriverEmailAbandonmentTrackingFired: boolean;
  private _primaryDriverIdNumberAbandonmentTrackingFired: boolean;
  private _primaryDriverPassportNumberAbandonmentTrackingFired: boolean;
  private _primaryDriverDateOfBirthAbandonmentTrackingFired: boolean;
  private _primaryDriverGenderAbandonmentTrackingFired: boolean;
  private _primaryDriverYearsWithPreviousInsurerAbandonmentTrackingFired: boolean;

  constructor(private discoveryGA4AngularService: DiscoveryGa4AngularService, private quotationService: QuotationService) {}

  set formName(value: string) {
    this._formName = value;
  }

  set leadRef(value: Number) {
    this._leadRef = value;
  }

  set dobFieldAbandonmentTrackingFired(value: boolean) {
    this._dobFieldAbandonmentTrackingFired = value;
  }


  get registrationAbandonmentTrackingFired(): boolean {
    return this._registrationAbandonmentTrackingFired;
  }

  set registrationAbandonmentTrackingFired(value: boolean) {
    this._registrationAbandonmentTrackingFired = value;
  }

  get vinAbandonmentTrackingFired(): boolean {
    return this._vinAbandonmentTrackingFired;
  }

  set vinAbandonmentTrackingFired(value: boolean) {
    this._vinAbandonmentTrackingFired = value;
  }


  get dobFieldAbandonmentTrackingFired(): boolean {
    return this._dobFieldAbandonmentTrackingFired;
  }


  get suburbAbandonmentTrackingFired(): boolean {
    return this._suburbAbandonmentTrackingFired;
  }

  set suburbAbandonmentTrackingFired(value: boolean) {
    this._suburbAbandonmentTrackingFired = value;
  }

  get selectSecurityAbandonmentTrackingFired(): boolean {
    return this._selectSecurityAbandonmentTrackingFired;
  }

  set selectSecurityAbandonmentTrackingFired(value: boolean) {
    this._selectSecurityAbandonmentTrackingFired = value;
  }

  get primaryDriverNameAbandonmentTrackingFired(): boolean {
    return this._primaryDriverNameAbandonmentTrackingFired;
  }

  set primaryDriverNameAbandonmentTrackingFired(value: boolean) {
    this._primaryDriverNameAbandonmentTrackingFired = value;
  }

  get primaryDriverSurnameAbandonmentTrackingFired(): boolean {
    return this._primaryDriverSurnameAbandonmentTrackingFired;
  }

  set primaryDriverSurnameAbandonmentTrackingFired(value: boolean) {
    this._primaryDriverSurnameAbandonmentTrackingFired = value;
  }

  get primaryDriverCellNumberAbandonmentTrackingFired(): boolean {
    return this._primaryDriverCellNumberAbandonmentTrackingFired;
  }

  set primaryDriverCellNumberAbandonmentTrackingFired(value: boolean) {
    this._primaryDriverCellNumberAbandonmentTrackingFired = value;
  }

  get primaryDriverEmailAbandonmentTrackingFired(): boolean {
    return this._primaryDriverEmailAbandonmentTrackingFired;
  }

  set primaryDriverEmailAbandonmentTrackingFired(value: boolean) {
    this._primaryDriverEmailAbandonmentTrackingFired = value;
  }

  get primaryDriverIdNumberAbandonmentTrackingFired(): boolean {
    return this._primaryDriverIdNumberAbandonmentTrackingFired;
  }

  set primaryDriverIdNumberAbandonmentTrackingFired(value: boolean) {
    this._primaryDriverIdNumberAbandonmentTrackingFired = value;
  }

  get primaryDriverPassportNumberAbandonmentTrackingFired(): boolean {
    return this._primaryDriverPassportNumberAbandonmentTrackingFired;
  }

  set primaryDriverPassportNumberAbandonmentTrackingFired(value: boolean) {
    this._primaryDriverPassportNumberAbandonmentTrackingFired = value;
  }

  get primaryDriverDateOfBirthAbandonmentTrackingFired(): boolean {
    return this._primaryDriverDateOfBirthAbandonmentTrackingFired;
  }

  set primaryDriverDateOfBirthAbandonmentTrackingFired(value: boolean) {
    this._primaryDriverDateOfBirthAbandonmentTrackingFired = value;
  }

  get primaryDriverGenderAbandonmentTrackingFired(): boolean {
    return this._primaryDriverGenderAbandonmentTrackingFired;
  }

  set primaryDriverGenderAbandonmentTrackingFired(value: boolean) {
    this._primaryDriverGenderAbandonmentTrackingFired = value;
  }

  get primaryDriverYearsWithPreviousInsurerAbandonmentTrackingFired(): boolean {
    return this._primaryDriverYearsWithPreviousInsurerAbandonmentTrackingFired;
  }

  set primaryDriverYearsWithPreviousInsurerAbandonmentTrackingFired(value: boolean) {
    this._primaryDriverYearsWithPreviousInsurerAbandonmentTrackingFired = value;
  }

  public postGtmEvent(event, formAction?, formStep?) {
    const postMessage = {
      'event': event,
      'event_parameters': {
        'form_name': this._formName,
        'form_action': formAction,
        'form_step': formStep,
        'lead_id': this._leadRef
      },
      'sentFrom': 'angular-iframe'
    };
    if (!this._leadRef) {
      delete postMessage.event_parameters.lead_id;
    }
    if (!formAction) {
      delete postMessage.event_parameters.form_action;
    }
    if (!formStep) {
      delete postMessage.event_parameters.form_step;
    }
    if (event === 'generate_lead') {
      postMessage['user'] = {
        'first_name': this.quotationService.quotationRequest.name,
        'last_name': this.quotationService.quotationRequest.surname,
        'email': this.quotationService.quotationRequest.email,
        'phone': this.quotationService.quotationRequest.cellphone.replace(this.quotationService.quotationRequest.cellphone.charAt(0), '+27')
      };
    }
    this.discoveryGA4AngularService.postMessage(postMessage);
  }

}
